import React from 'react'

export const Bad = () => (
  <svg
    aria-label="Bad"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_114_1947)">
      <path
        d="M24.5417 17.4167C25.8534 17.4167 26.9167 16.3533 26.9167 15.0417C26.9167 13.73 25.8534 12.6667 24.5417 12.6667C23.23 12.6667 22.1667 13.73 22.1667 15.0417C22.1667 16.3533 23.23 17.4167 24.5417 17.4167Z"
        fill="#E2551D"
      />
      <path
        d="M13.4583 17.4167C14.77 17.4167 15.8333 16.3533 15.8333 15.0417C15.8333 13.73 14.77 12.6667 13.4583 12.6667C12.1466 12.6667 11.0833 13.73 11.0833 15.0417C11.0833 16.3533 12.1466 17.4167 13.4583 17.4167Z"
        fill="#E2551D"
      />
      <path
        d="M19 22.1667C15.3109 22.1667 12.16 24.4625 10.8934 27.7083H13.5375C14.63 25.8242 16.6567 24.5417 19 24.5417C21.3434 24.5417 23.3542 25.8242 24.4625 27.7083H27.1067C25.84 24.4625 22.6892 22.1667 19 22.1667ZM18.9842 3.16667C10.2442 3.16667 3.16669 10.26 3.16669 19C3.16669 27.74 10.2442 34.8333 18.9842 34.8333C27.74 34.8333 34.8334 27.74 34.8334 19C34.8334 10.26 27.74 3.16667 18.9842 3.16667ZM19 31.6667C12.0017 31.6667 6.33335 25.9983 6.33335 19C6.33335 12.0017 12.0017 6.33333 19 6.33333C25.9984 6.33333 31.6667 12.0017 31.6667 19C31.6667 25.9983 25.9984 31.6667 19 31.6667Z"
        fill="#E2551D"
      />
    </g>
    <defs>
      <clipPath id="clip0_114_1947">
        <rect width="38" height="38" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
